import { useFormik } from "formik";
import { Modal } from "react-bootstrap";
import { Button } from "../../../../components";
import {
  FalseReportForm,
  INITIAL_VALUES,
  VALIDATION_SCHEMA
} from "../../../../components/false-report-form";
import { NotificationsLevel } from "../../../../lib/enums";
import { show as showNotification } from "../../../../notifications/notifications";
import {
  ErrorResponse,
  MessageErrorResponse
} from "../../../../requests/@types";
import api from "../../api";

type Props = {
  show: boolean;
  sha1: string;
  onClose: () => void;
};

const FalseReportModal = ({ show, sha1, onClose }: Props) => {
  const formik = useFormik({
    initialValues: INITIAL_VALUES,
    validationSchema: VALIDATION_SCHEMA,
    validateOnMount: true,
    onSubmit: values => {
      api
        .postFalseReport(sha1, values.type, values.comment, values.contact)
        .then(() => {
          showNotification({
            level: NotificationsLevel.SUCCESS,
            message: `False Positive/Negative reported successfully submitted for the ${sha1}!`
          });
        })
        .catch((data: ErrorResponse<MessageErrorResponse>) => {
          showNotification({
            level: NotificationsLevel.ERROR,
            message: data.data.message
          });
        });
      onClose();
    }
  });

  return (
    <Modal show={show} size="lg" onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Report False Positive/Negative</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FalseReportForm formik={formik} />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} variant="secondary">
          CANCEL
        </Button>
        <Button
          variant="primary"
          disabled={formik.isSubmitting || !formik.isValid}
          onClick={() => formik.submitForm()}
        >
          SEND
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FalseReportModal;
